module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-solutions"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-solution-landing"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageSolution.header_text) ? _c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.pageSolution.header_text.value))]), _vm._v(" "), (_vm.pageSolution.intro_paragraph) ? _c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "intro_text"
  }, [_vm._v(_vm._s(_vm.pageSolution.intro_paragraph.value))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.solutions,
      "modularContent": _vm.modularContent,
      "isHome": false,
      "boxlimit": 1000,
      "pathRoute": '/solutions',
      "showCategory": false
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a37832a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Solutions.vue
// module id = 1546
// module chunks = 0